import { useState } from "react"
import { motion } from "motion/react"
import { IconChevronExpandYOutline18 as ChevronsUpDown } from "nucleo-ui-outline-18"

import type { TimelineEvent } from "@productlane/api/src/browser"
import { Avatar } from "@productlane/ui"

import { CommentEvent } from "./comment-event"
import {
	resolvedCommentAuthorAvatars,
	resolvedCommentsLabel,
} from "./resolved-comment-runs"

export function ResolvedCommentsRun({ events }: { events: TimelineEvent[] }) {
	const [isExpanded, setExpanded] = useState(false)
	const { authors, overflow } = resolvedCommentAuthorAvatars(events, 2)

	return (
		<div className="py-1">
			<button
				type="button"
				onClick={() => setExpanded(!isExpanded)}
				className="group flex w-full items-center py-1.5"
			>
				<span className="h-px flex-1 bg-gray-200 dark:bg-gray-700/80" />
				<span className="mx-2.5 flex items-center gap-2 rounded-full border border-gray-200 bg-gray-25 px-2.5 py-[3px] group-hover:bg-gray-100 dark:border-gray-700/80 dark:bg-gray-900 dark:group-hover:bg-gray-800">
					<span className="flex flex-none items-center gap-1">
						{authors.map((author) => (
							<Avatar
								key={author.key}
								size="xxs"
								roundness="full"
								name={author.name}
								image={author.image}
							/>
						))}
					</span>
					<span className="whitespace-nowrap text-[11.5px] text-tertiary group-hover:text-secondary">
						{resolvedCommentsLabel(events)}
						{overflow > 0 ? ` +${overflow}` : ""}
					</span>
					<ChevronsUpDown className="h-3.5 w-3.5 flex-none text-tertiary" />
				</span>
				<span className="h-px flex-1 bg-gray-200 dark:bg-gray-700/80" />
			</button>
			{isExpanded && (
				<motion.div
					initial={{ opacity: 0, y: -3 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.12, ease: [0.16, 1, 0.3, 1] }}
				>
					{events.map((event) =>
						event.type === "comment" ? (
							<CommentEvent
								key={`resolved-comment-${event.comment.id}`}
								event={event}
								showAvatar
							/>
						) : null,
					)}
				</motion.div>
			)}
		</div>
	)
}
